import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-primary-violet min-h-[210px] px-7 py-5 flex flex-col gap-5 z-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white font-bold text-center leading-5" }, "Are you an OG beanie? Migrate your data from the old Workbean.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/account-login-and-security",
  class: "bg-white text-primary-black font-bold py-3 rounded-lg text-center"
}, "Migrate", -1)

import { computed, onMounted, ref, onUpdated, watch } from "vue"
  import { toastController } from "@ionic/vue"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useAccountStore } from "@/store/account"
  import jwt from "@/utils/jwt"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'migrateBanner',
  setup(__props) {

  const accountStore = useAccountStore()
  const authenticationStore = useAuthenticationStore()
  const hide = ref(true)

  // hide banner on user "no thanks" click
  const hideBanner = async () => {
    accountStore.hide_migration_banner = true
    await accountStore.updateAny(jwt.generateNBF())
    const toast = await toastController.create({
      message: "Current account details retained.",
      duration: 3000,
      position: "top",
      color: "success",
    })
    await toast.present()
  }

  onMounted(() => {
    hide.value = accountStore.hide_migration_banner
  })

  watch(
    () => accountStore.hide_migration_banner,
    (val) => {
      hide.value = val
    }
  )

return (_ctx: any,_cache: any) => {
  return (!hide.value && _unref(accountStore).type === 'professional' && _unref(authenticationStore).token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "bg-white text-primary-black font-bold py-3 rounded-lg",
          onClick: hideBanner
        }, "No thanks"),
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
}
}

})